import ApiService from "../api";

function paramsDe(filtros = {}) {
    const params = new URLSearchParams();
    Object.entries(filtros).forEach(([chave, valor]) => {
        if (valor !== null && valor !== undefined && valor !== "") params.append(chave, valor);
    });
    return params;
}

export default class DespesaRecorrenteService extends ApiService {

    constructor() {
        super('/api/solicitacoes/despesas-recorrentes')
    }

    criar(dados) {
        return this.post(``, dados);
    }

    atualizar(id, dados) {
        return this.put(`/${id}`, dados);
    }

    ativarDesativar(id, ativo) {
        return this.patch(`/${id}/ativo?ativo=${ativo}`);
    }

    buscar(id) {
        return this.get(`/${id}`);
    }

    historico(id) {
        return this.get(`/${id}/historico`);
    }

    listar(filtros = {}) {
        return this.get(`?${paramsDe(filtros)}`);
    }

    listarOcorrencias(filtros = {}) {
        return this.get(`/ocorrencias?${paramsDe(filtros)}`);
    }

    buscarOcorrencia(id) {
        return this.get(`/ocorrencias/${id}`);
    }

    prefillRecorrencia(ocorrenciaId) {
        return this.get(`/ocorrencias/${ocorrenciaId}/prefill-recorrencia`);
    }

    prefillUltimoLancamento(ocorrenciaId) {
        return this.get(`/ocorrencias/${ocorrenciaId}/prefill-ultimo-lancamento`);
    }

    marcarComoLancado(ocorrenciaId, observacao, numeroSolicitacao) {
        return this.post(`/ocorrencias/${ocorrenciaId}/marcar-lancado`, { observacao, numeroSolicitacao });
    }

    reabrir(ocorrenciaId) {
        return this.post(`/ocorrencias/${ocorrenciaId}/reabrir`);
    }

    cancelarOcorrencia(ocorrenciaId) {
        return this.post(`/ocorrencias/${ocorrenciaId}/cancelar`);
    }

    cancelarOcorrenciasFuturas(despesaRecorrenteId) {
        return this.post(`/${despesaRecorrenteId}/cancelar-futuras`);
    }

    kpis(filtros = {}) {
        return this.get(`/kpis?${paramsDe(filtros)}`);
    }
}
